import React, { useState } from "react";
import "../supplierAndManufacturers.scss";
import CompanyItem from "./CompanyItem";

const CompanyData = [{
  id: 0,
  companyName: 'Morrisons Distillery',
  companyIcon: '/images/settings-v2/logo.svg',
},
{
  id: 1,
  companyName: 'Morrisons Distillery',
  companyIcon: '/images/settings-v2/logo.svg',
},
{
  id: 2,
  companyName: 'Morrisons Distillery',
  companyIcon: '/images/settings-v2/logo.svg',
},
{
  id: 3,
  companyName: 'Morrisons Distillery',
  companyIcon: '/images/settings-v2/logo.svg',
}]

const CompanyTablesBlock = ({
  headersList = [],
  data = [],
  searchString = '',
  sortOrder=0,
  setSortOrder = () => {},
  getMSPAllSupplierManufacturer = () => { },
  setHeadersList = () => { },
  onItemClick = () => { },
  onAddClick = () => { }
}) => {
  return (
    <div className="companyItem">
      {
        data?.ClientRowData_List?.map((companyDataItem) => (
          <CompanyItem
            headersList={headersList}
            data={data}
            searchString={searchString}
            sortOrder={sortOrder}
            setSortOrder={setSortOrder}
            getMSPAllSupplierManufacturer={getMSPAllSupplierManufacturer}
            setHeadersList={setHeadersList}
            companyDataItem={companyDataItem}
            onItemClick={onItemClick}
            onAddClick={onAddClick}
          />
        ))
      }
    </div>
  );
};

export default CompanyTablesBlock;
